module.exports = __webpack_public_path__ + "./fonts/Aino-Bold.otf";